module.exports = __webpack_public_path__ + "assets/img/phone0.064c759c.png";